import React from 'react';

import { UserSquare } from 'iconsax-react';

import classes from './planFeatureList.module.scss';

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const boldify = (text, bold) => {
    if (!bold || bold.length === 0) return text;
    const pattern = bold.map(escapeRegExp).join('|');
    return text
        .split(new RegExp(`(${pattern})`, 'g'))
        .map((part, index) => (bold.includes(part) ? <strong key={index}>{part}</strong> : part));
};

const PlanFeatureList = ({ features }) => {
    return (
        <ul className={classes['features']}>
            {features.map((feature) => {
                if (feature.type === 'label') {
                    return (
                        <li key={feature.id} className={classes['label']}>
                            {feature.description}
                        </li>
                    );
                }

                if (feature.type === 'highlight') {
                    return (
                        <li
                            key={feature.id}
                            className={`${classes['highlight']} ${feature.icon ? classes['with-icon'] : ''}`}
                        >
                            {feature.icon
                                ? (
                                    <span className={classes['highlight-icon']}>
                                        <UserSquare size="26" color="#18BBA8" />
                                    </span>
                                )
                                : <span className={classes['dot']} />
                            }
                            <span>
                                <span className={classes['highlight-title']}>{feature.title}</span>
                                {feature.note && <span className={classes['note']}>{feature.note}</span>}
                            </span>
                        </li>
                    );
                }

                return (
                    <li key={feature.id} className={classes['feature']}>
                        {boldify(feature.description, feature.bold)}
                        {feature.note && <span className={classes['note']}>{feature.note}</span>}
                    </li>
                );
            })}
        </ul>
    );
};

export default PlanFeatureList;
